import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    const toggle = document.getElementById("layout-navbar-toggle")
    if (toggle) toggle.checked = false
  }

  closeOnNavigate(event) {
    if (event.target.closest("a[href], button[type='submit']")) {
      this.close()
    }
  }
}
